<section
	class="toast-region"
	aria-label="Μηνύματα εφαρμογής"
	aria-live="polite"
>
	@for (message of messagesSrv.messages(); track message.id) {
		<article
			class="toast"
			[class.toast--success]="message.type === 'success'"
			[class.toast--error]="message.type === 'error'"
			[class.toast--info]="message.type === 'info'"
			[attr.role]="message.type === 'error' ? 'alert' : 'status'"
		>
			<span class="toast__icon" aria-hidden="true">
				{{
					message.type === 'success'
						? '✓'
						: message.type === 'error'
							? '!'
							: 'i'
				}}
			</span>
			<span class="toast__content">
				<strong>{{ message.title }}</strong>
				@if (message.detail) {
					<span>{{ message.detail }}</span>
				}
			</span>
			<button
				type="button"
				(click)="messagesSrv.dismiss(message.id)"
				aria-label="Κλείσιμο μηνύματος"
			>
				×
			</button>
		</article>
	}
</section>
